import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { PublicHeader } from './PublicHeader';
import { SiteFooter } from './SiteFooter';
import '../styles/public.css';

/**
 * The frame around the advert screens for somebody from the public (156).
 *
 * They signed up to post, not to manage property, so they get the public
 * header and their own "My listings" rather than the landlord app. The screens
 * inside are the landlord's own advert screens; the server scopes every row
 * to their account and the approval and payment gates apply as for anyone.
 */
export function PosterFrame({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return (
    <>
      <PublicHeader />
      <main style={{ maxWidth: 1100, margin: '0 auto', padding: '16px' }}>{children}</main>
      <SiteFooter />
    </>
  );
}
